import { useMemo, useState } from 'react';
import { SkupremeModal } from '../../../../../components';
import { HoverBorderButton, MuteText, StyledButton } from '../../../../../elements';
import { ToastMessage, WaveService } from '../../../../../utility';
import { createMergeConfirmationSession } from '../../../../../page-components/waves/wave-merge';

export function MergeWavePopup({
  checkedWaves,
  open,
  onClose,
  warehouseId,
  refresh,
  resetCheck,
}) {
  const [loading, setLoading] = useState(false);
  const confirmation = useMemo(
    () => (open ? createMergeConfirmationSession({ checkedWaves, warehouseId }) : null),
    [open, checkedWaves, warehouseId],
  );

  const mergeWaves = async () => {
    if (!confirmation?.destinationWave || confirmation.sourceWaveCount === 0) return;

    try {
      setLoading(true);
      await WaveService.mergeWaves(confirmation.payload);
      ToastMessage.success(
        `Waves merged into ${confirmation.destinationWave.waveNumber || confirmation.destinationWave._id}`,
      );
      resetCheck();
      onClose();
      refresh();
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SkupremeModal
      size="mini"
      open={open}
      title="Confirm Merging Waves"
      onClose={onClose}
    >
      <MuteText>{confirmation?.message}</MuteText>
      <div className="mt-3">
        <strong>Destination: </strong>
        {confirmation?.destinationWave?.waveNumber || confirmation?.destinationWave?._id}
      </div>
      {confirmation?.sourceWaves?.length > 0 ? (
        <div className="mt-2">
          <MuteText>Source waves:</MuteText>
          {confirmation.sourceWaves.map(wave => (
            <div className="d-flex" key={wave._id}>
              {wave.waveNumber || wave._id}
            </div>
          ))}
        </div>
      ) : null}
      <div className="d-flex justify-content-end mt-4">
        <HoverBorderButton onClick={onClose} disabled={loading}>
          Cancel
        </HoverBorderButton>
        <StyledButton onClick={mergeWaves} loading={loading} className="ml-1">
          Confirm
        </StyledButton>
      </div>
    </SkupremeModal>
  );
}
